import { render, staticRenderFns } from "./top-cart.vue?vue&type=template&id=1abdb408&scoped=true"
import script from "./top-cart.vue?vue&type=script&lang=ts"
export * from "./top-cart.vue?vue&type=script&lang=ts"
import style0 from "./top-cart.vue?vue&type=style&index=0&id=1abdb408&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abdb408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abdb408')) {
      api.createRecord('1abdb408', component.options)
    } else {
      api.reload('1abdb408', component.options)
    }
    module.hot.accept("./top-cart.vue?vue&type=template&id=1abdb408&scoped=true", function () {
      api.rerender('1abdb408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/cart/top-cart.vue"
export default component.exports